/* template */
<template><div :style="[(warpStyle)] | transRpxStyle" class="warp"><mpx-text :style="[(ruleStyle)] | transRpxStyle" @tap="gotoLink(pageConfig.rule.link)" class="rule">规则</mpx-text><mpx-image webp :src="(pageConfig.header.image2)" mode="widthFix" class="header-image"/><red-packet-open :template="(info.template)" :btnText="(btnText)" :couponList="(couponList)" @couponClick="couponToUse" @click="toUseCoupon" v-if="(hasGetCoupon && hasCoupon && couponList)"/><red-packet-close :config="(pageConfig.redPacket)" :couponInfo="(activityCouponInfo)" :template="(info.template)" :btnText="(btnText)" @click="getCoupon" v-else-if="(activityCouponInfo || pageConfig)"/><image-list :imageList="(pageConfig.imageList)"/><res-banner :template="(info.template)" v-if="(activityCouponInfo)"/><popup-result :popupData="(popupResult)" :pageConfig="(pageConfig)" @close="popupClose" @click="popupClick" v-if="(popupResult)"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m43b9d13c"}'>
  @font-face {
    font-family: DIN-Bold-self;
    src: url(https://dpubstatic.udache.com/static/dpubimg/5e78fa44-928b-4132-aa31-d5bac7b67ece.ttf);
  }
  .warp
    min-height 100vh
    width 100vw
    padding-bottom 180rpx
    font-size: 0;
    overflow hidden
    box-sizing: border-box;
    background-size 100vw auto
    background-repeat no-repeat
    line-height: normal;
    position relative
    .rule
      position absolute
      right 0
      border-radius: 100rpx 0 0 100rpx;
      font-family: PingFangSC-Semibold;
      font-size: 24rpx;
      letter-spacing: 1rpx;
      font-weight: bold
      padding 4rpx 16rpx 4rpx 25rpx
    .header-image
      width: 750rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m43b9d13c"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex43b9d13c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./index.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Findex43b9d13c%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m43b9d13c"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index43b9d13c/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'image-list':getComponent(require("../../components/common/image-list.mpx?isComponent&outputPath=components%2Fimage-list73d9d186%2Findex")),'res-banner':getComponent(require("../../components/common/res-banner.mpx?isComponent&outputPath=components%2Fres-banner12bfcde6%2Findex")),'red-packet-close':getComponent(require("../../components/common/red-packet-close.mpx?isComponent&outputPath=components%2Fred-packet-close937b2cc8%2Findex")),'red-packet-open':getComponent(require("../../components/common/red-packet-open.mpx?isComponent&outputPath=components%2Fred-packet-open09b1ea94%2Findex")),'popup-result':getComponent(require("../../components/hy/popup-result.mpx?isComponent&outputPath=components%2Fpopup-result780e2836%2Findex")),'mpx-text':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-text.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
